import React from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

export function ReplacementModal({ isOpen, replacement, onConfirm, onClose }) {
  return (
    <Modal isOpen={isOpen} contentLabel="Add Note" className="confirm-modal">
      <div className="card">
        <button onClick={onClose} className="confirm-modal-close">
          <MdClose />
        </button>
        <div className="card-header">Device Replacement</div>
        <form>
          <div className="card-body">
            {replacement ? (
              <div className="mb-3">
                Do you really want to replace current device?
              </div>
            ) : (
              <div className="mb-3">Please add replacement device first?</div>
            )}
            <button
              type="submit"
              className="btn btn-outline-primary mr-3"
              data-testid="modal-approve-btn"
              onClick={onConfirm}
            >
              Confirm
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
              data-testid="modal-approve-btn-cancel"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
